import { Text, View, StyleSheet } from '@react-pdf/renderer';

const styles = StyleSheet.create({
    titleContainer: {
        flexDirection: 'row',
        marginTop: 24,
        fontSize: 12
    },
    reportTitle: {
        fontSize: 10,
        fontFamily: 'Helvetica-Bold',
        textAlign: 'center'
    }
});

const LegacyReceiptTitle = () => (
    <View style={styles.titleContainer}>
        <Text style={styles.reportTitle}>
            Pre 2025 summary
        </Text>
    </View>
);

export default LegacyReceiptTitle;